import React from "react";
import { Link } from "react-router-dom";
import facebook from "../../assets/img/social/facebook.png";
import whatsapp from "../../assets/img/social/whatsapp.png";
import instagram from "../../assets/img/social/instagram.png";
import ReactWhatsapp from "react-whatsapp";
const socialMediaUrl = [
  {
    id: "2",
    imgurl: instagram,
    sociallink: "#",
  },
  {
    id: "2",
    imgurl: facebook,
    sociallink: "#",
  },
];
function SocialMedia() {
  const obj = {
    id: "1",
    imgurl: whatsapp,
    sociallink:
      "#",
  };
  return (
    <div className="position-fixed z-9 top-50">
      <div className="socialItem">
        <a href="#" >
          <img src={obj.imgurl} alt="socialLink" width={30} />
        </a>
      </div>
      {socialMediaUrl.map((item, key) => {
        return (
          <div key={key} className="socialItem">
            <a href="#" target="_blank">
              <img src={item.imgurl} alt="socialLink" width={30} />
            </a>
          </div>
        );
      })}
    </div>
  );
}

export default SocialMedia;
